module.exports = __webpack_public_path__ + "media/customizations/lewiscommunities/back-4c29971ca5ae266fee4a24235312000b.jpg";